import { NgModule } from '@angular/core';
import  {CommonModule} from '@angular/common'
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NumericDirective } from '../Validation/onlynumbernumeric.directive';
import { MasterRoutingModule } from './master-routing.module';
import { EmployeeMasterComponent } from './employeemaster/employeemaster.component';
import { AddEmployeeMasterComponent } from './addemployeemaster/addemployeemaster.component';
import { HqMasterComponent } from './hqmaster/hqmaster.component';
import { AddHQMasterComponent } from './addhqemaster/addhqmaster.component';
import { AreaBeetMasterComponent } from './areabeetmaster/areabeetmaster.component';
import { ChemistMasterComponent } from './chemistmaster/chemistmaster.component';
import { from } from 'rxjs';
import { AddAreabeetMasterComponent } from './addareabeetemaster/addareabeetmaster.component';
import { StockistMasterComponent } from './stockistmaster/stockistmaster.component';
import { AgGridModule } from 'ag-grid-angular';
import { AddChemistMasterComponent } from './addchemistmaster/addchemistmaster.component';
import { ExpenseMasterComponent } from './expensemaster/expensemaster.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ProductPriceListComponent } from './productpricelist/productpricelist.component';
import { RouteMasterComponent } from './routemaster/routemaster.component';
import { RouteListComponent } from './routelist/routelist.component';
import { GooglePlaceModule } from 'ngx-google-places-autocomplete';
import { AreaListMasterComponent } from './arealistmaster/arealistmaster.component';
import { chemistregresetComponent } from './chemistmaster/chemistregreset.component';
import { ChemistListTransfer } from './chemistlisttransfer/chemistlisttransfer.component';
import { QPSschemeMasterComponent } from './qpsschememaster/qpsschememaster.component';



@NgModule({
    imports: [
        CommonModule,
        NgbModule,
        AgGridModule.withComponents([]),
        MasterRoutingModule,
        FormsModule,
        GooglePlaceModule,
        ReactiveFormsModule
     ],
    declarations: [
        EmployeeMasterComponent,
        AddEmployeeMasterComponent,
        HqMasterComponent,
        AreaBeetMasterComponent,
        AddHQMasterComponent,
        ChemistMasterComponent,
        AddChemistMasterComponent,
        AddAreabeetMasterComponent,
        StockistMasterComponent,
        ExpenseMasterComponent,
        ProductPriceListComponent,
        RouteMasterComponent,
        RouteListComponent,
        AreaListMasterComponent,
        chemistregresetComponent,
        NumericDirective,ChemistListTransfer,
        QPSschemeMasterComponent
    ],
    providers: [ ],
    exports: [
        RouterModule, 
        EmployeeMasterComponent,
        AddEmployeeMasterComponent,
        NumericDirective
    ]
})
export class MasterModule {

}
